module.exports = new __parcel__URL__("components.37259031.svg").toString();